import { Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { STREAM_URL, API } from "@/lib/api";

export const copy = async (text, label = "Copied") => {
  try { await navigator.clipboard.writeText(text); toast.success(label); }
  catch { toast.error("Could not copy. Select and copy it manually."); }
};

export const StreamLinks = () => (
  <section className="rise max-w-3xl mx-auto w-full" style={{ animationDelay: "0.25s" }} data-testid="stream-links-section">
    <h3 className="section-title">~ listen in your player ~</h3>
    <p className="text-sm text-center mb-4" style={{ color: "var(--t-muted)" }}>paste this link into VLC, Winamp, your car or smart speaker · mp3 · 128 kbps</p>
    <div className="dash-card flex items-center gap-2 p-2 pl-4">
      <code className="text-xs sm:text-sm truncate flex-1" style={{ color: "var(--t-label)" }} data-testid="public-player-stream-url">{STREAM_URL}</code>
      <button onClick={() => copy(STREAM_URL, "Stream link copied")} className="pill-on rounded-full px-4 py-1.5 text-sm font-bold flex items-center gap-1.5" data-testid="public-player-stream-url-copy">
        <Copy className="w-4 h-4" /> copy
      </button>
    </div>
    <div className="text-center mt-3">
      <a href={`${API}/stream.m3u`} className="inline-flex items-center gap-2 text-sm hover:underline" style={{ color: "var(--t-label)" }} data-testid="public-player-m3u-link">
        <Download className="w-4 h-4" /> download .m3u playlist
      </a>
    </div>
  </section>
);
